import type { GameState, GameResult, Side } from '../types/game-state';
import { getTotalPopulation } from './world-data';
import { getReadyWeapons } from './arsenal';

function computeScore(state: GameState): GameResult {
  const usPop = getTotalPopulation(state.world.usCities);
  const ussrPop = getTotalPopulation(state.world.ussrCities);
  const originalUsPop = state.world.usCities.reduce((s, c) => s + c.population, 0);
  const originalUssrPop = state.world.ussrCities.reduce((s, c) => s + c.population, 0);
  const usCasualties = originalUsPop - usPop;
  const ussrCasualties = originalUssrPop - ussrPop;
  const globalCasualties = usCasualties + ussrCasualties;

  const usRemaining = getReadyWeapons(state.usArsenal).length;
  const ussrRemaining = getReadyWeapons(state.ussrArsenal).length;

  const usPopPercent = usPop / originalUsPop;
  const ussrPopPercent = ussrPop / originalUssrPop;

  let winner: Side | 'draw' | 'mutual_destruction';
  if (usPopPercent < 0.15 && ussrPopPercent < 0.15) {
    winner = 'mutual_destruction';
  } else if (Math.abs(usPopPercent - ussrPopPercent) < 0.05) {
    winner = 'draw';
  } else {
    winner = usPopPercent > ussrPopPercent ? 'US' : 'USSR';
  }

  return {
    winner,
    usPopulationSurviving: usPop,
    ussrPopulationSurviving: ussrPop,
    usCasualties,
    ussrCasualties,
    globalCasualties,
    usArsenalRemaining: usRemaining,
    ussrArsenalRemaining: ussrRemaining,
    roundsPlayed: state.currentRound,
  };
}

export { computeScore };
